import donnees from "./villes.json";

export type PageVille = {
  slug: string;
  nom: string;
  region: string;
  populationApprox: number;
  distanceKm: number;
  /** Cible de mots de la page rendue, mesuree sur le <main>. Elle vient du
      tableau « Cible par ville proposee » de
      docs/superpowers/plans/controles-serp-villes.md, soit
      max(1200, mediane du SERP + 20 %) arrondi a la centaine. Une seule cible
      commune ne tenait pas : le SERP va de 841 mots a Rimouski a 2 187 a
      Sept-Iles. PageVille.test.tsx la rend executable. */
  cibleMots: number;
  /** Date de derniere revision reelle du contenu, format YYYY-MM-DD.
      Alimente <lastmod> et dateModified. Ne se met a jour que quand le
      texte change, jamais a chaque build. */
  misAJour: string;
  secteurPhare: { nom: string; pourquoi: string; besoinsWeb: string[] };
  projetsMisEnAvant: string[];
  aidesNumeriques: { nom: string; organisme: string; url: string }[];
  faq: { question: string; reponse: string }[];
  motsCles: { principal: string; secondaires: string[] };
  meta: { title: string; description: string };
  redaction: {
    accroche: string;
    /** 40 a 60 mots. Repond directement a la question, sans argumentaire.
        C'est ce bloc que les moteurs generatifs decoupent pour citer. */
    reponseExtractible: string;
    marcheLocal: string;
    travailADistance: string;
  };
  villesVoisines: string[];
};

export const villes: PageVille[] = donnees as PageVille[];

export function trouverVille(slug: string): PageVille | undefined {
  return villes.find((v) => v.slug === slug);
}

export function compterMots(texte: string): number {
  return texte.trim().split(/\s+/).filter(Boolean).length;
}
